module.exports = __webpack_public_path__ + "img/pratiche-emt.9a4aa050.png";